import { FC, memo, useCallback } from 'react'

import { Box, Stack, Typography } from '@mui/material'
import {
  errorToString,
  gtmEvents,
  SocialLoginType,
  SubmissionTrackingStatus,
} from '@procom-labs/common'

import { environment } from '@auth-portal/environment'
import { useTrackingWrapper } from '@auth-portal/hooks'
import { useMsSsoLogin } from '@auth-portal/hooks/use-ms-sso-login'

interface IMicrosoftLoginButtonProps {
  handleError?: (errorMessage: string | undefined) => void
}

const loginButtonText = 'Microsoft 365'

export const MicrosoftLoginButton: FC<IMicrosoftLoginButtonProps> = memo(
  ({ handleError }) => {
    const { track } = useTrackingWrapper()
    const { handleMsSsoLogin } = useMsSsoLogin()

    const handleClick = useCallback(async () => {
      try {
        await handleMsSsoLogin(handleError)
      } catch (error) {
        track({
          eventName: gtmEvents.FormMsSSOLogin,
          submissionStatus: SubmissionTrackingStatus.Failed,
          loginType: 'MS_SSO_Login',
          isGTMTracking: true,
          isMixPanelTracking: true,
          isTrackingEnabled: true,
          errorMessage: errorToString(error),
        })
      }
    }, [track, handleError, handleMsSsoLogin])

    return (
      <Stack
        direction="row"
        spacing={1.5}
        justifyContent="center"
        alignItems="center"
        sx={{ cursor: 'pointer' }}
        mb={2}
        onClick={handleClick}
        aria-label="Microsoft 365 Login"
      >
        <Box
          component="img"
          alt={SocialLoginType.Microsoft}
          src={`${
            environment.BLOB_STORAGE_URL
          }/procom-portal-assets/icons/${SocialLoginType.Microsoft.toLocaleLowerCase()}.png`}
        />
        <Typography component="p" variant="subtitle1" ml={1}>
          {loginButtonText}
        </Typography>
      </Stack>
    )
  }
)
